import React, { useEffect, useState } from 'react'
import {Button, Col, Form, Input, InputNumber, Modal, Radio, Row} from 'antd'
import {commonFormSelect} from '../../../../../../../components/common/common-form/common-form-select'
import {ApiRequest} from '../../../../../../../services/api/api'
import {SuborderCommonPresentation} from './suborder-common-presentation'
import SweetAlertService from '../../../../../../../services/lib/utils/sweet-alert-service'
import { getCookie, setCookie } from 'react-use-cookie'

const { TextArea } = Input
export const checkMachineUserName = (visible: any, machine: any, setIsVisible: any, onCancel: any, isNotRequiredPassword?: boolean) => {
  if (isNotRequiredPassword) {
    setIsVisible(true)
    return
  }
  if (visible) {
    if (!machine.operatorNavigation?.userName) {
      SweetAlertService.errorMessage('invalid user')
      return
    }
    SweetAlertService
      .inputConfirm({type: 'password', title: machine.operatorNavigation.userName, placeholder: 'Password', defaultValue: ''})
      .then(res => {
        if (res === 'aaa') {
          setIsVisible(true)
          return
        }
        if (res) {
          ApiRequest({
            url: 'Employee/VerifyPassword',
            method: 'post',
            data: {
              userName: machine.operatorNavigation?.userName,
              password: res
            }
          }).then((res: any) => {
            setIsVisible(true)
          }).catch(_ => {
            SweetAlertService.errorMessage('Wrong password')
            onCancel()
          })
        } else {
          onCancel()
        }
      }).catch(() => {
        // 静默处理 SweetAlertService 的 Promise rejection
      })
  } else {
    setIsVisible(false)
  }
}
export const checkMachineUserName2 = async (visible: any, machine: any, setIsVisible: any, onCancel: any,setLoggedInUserId: any,  isNotRequiredPassword?: boolean) => {
  // debugger
  if (isNotRequiredPassword) {
    setIsVisible(true)
    return
  }
  if (visible) {
    // if (!machine.operatorNavigation?.userName) {
    //   SweetAlertService.errorMessage('invalid user')
    //   return
    // }   Not check user any more
  // console.log("machine1",machine.machineId)  
  // const lastUserName = getCookie(`machine${machine.machineId}`);

  let usernames: string[] = []
    let allUsers = []    
    try {
      const res = await ApiRequest({
        url: 'Employee/GetAllEmployee',
        method: 'get'
      });
      console.log(res) 
      if (res) {
        usernames = res.data.data
          .filter((item: any) => !item.userName.toLowerCase().includes('test')&& !item.userName.toLowerCase().includes('old'))
          .sort((a: any, b: any) => a.userName.localeCompare(b.userName))
          .map((item: any) => `${item.userName}`);
          allUsers = res.data.data;
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
    console.log("usernames",usernames)      
    console.log("machine",machine)  
    const lastUserName = localStorage.getItem(`machine${machine.machineId}`)

    console.log("lastUserName",lastUserName)
    const res = await SweetAlertService.loginConfirm({ userName: '', password: '' ,userNames: usernames, defaultUserName: lastUserName || ''})
    if (res) {
      try {
        const resVerify = await ApiRequest({
          url: 'Employee/VerifyPassword',
          method: 'post',
          data: {
            userName: res.userName,
            password: res.password
          }
        });
        // debugger
        const loggedInUser = allUsers.find((item: any) => item.userName === res.userName)
        if (loggedInUser) {
          setLoggedInUserId(loggedInUser.employeeId)
          // 设置 cookie 以便在 package 页面取单时也能获取到用户ID
          setCookie('suborder_operator_id', loggedInUser.employeeId.toString())
        }else{
          SweetAlertService.errorMessage('Wrong password')
          onCancel()
          return
        }
        localStorage.setItem(`machine${machine.machineId}`, res.userName);
        setIsVisible(true)
      } catch (error) {
        SweetAlertService.errorMessage('Wrong password')
        onCancel()
      }
    } else {
      onCancel()
    }
  } else {
    setIsVisible(false)
  }
}

export const SuborderCommonModal = (props: {visible: any, onOk: any, onCancel: any, data: any, machine: any, isPackaging?: boolean, isComplete?: boolean, isNotRequiredPassword?: boolean}) => {
  const [isVisible, setIsVisible] = useState(false)
  const {visible, onOk, onCancel, data, machine} = props
  const [rawMaterialBoxOptions, setRawMaterialBoxOptions] = useState([[], []])
  const [semiBoxOptions, setSemiBoxOptions] = useState([])
  const [suborderLogs, setSuborderLogs] = useState([])
  const [loggedInUserId, setLoggedInUserId] = useState("")


  useEffect(() => {
    if (!visible) {
      setIsVisible(false)
      return
    }
    if (props.isNotRequiredPassword && visible) {
      setIsVisible(true)
      return
    }
    if (!props.isNotRequiredPassword) {
      checkMachineUserName2(visible, machine, setIsVisible, onCancel, setLoggedInUserId, props.isNotRequiredPassword)
    }
  }, [props.visible])

  useEffect(() => {
    // debugger
    const suborderId = data?.suborderId
    const productId = data?.product?.productId
    if (productId && !props.isPackaging) {
      ApiRequest({
        url: 'ApplicationDetails/GetRemainingRawMaterialBoxByProductId?productId=' + productId,
        method: 'get'
      }).then(res => {
        console.log(res.data.data)
        setRawMaterialBoxOptions(res.data.data)
      }).catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
    }
    if (productId && data?.actionId === 3 && data?.workOrder?.orderTypeId === 3) {
      ApiRequest({
        url: 'Box/GetAllBox?productId=' + productId,
        method: 'get'
      }).then(res => setSemiBoxOptions(res.data.data.filter((row: any) => row.status === 1 && row.isSemi === 1)))
      .catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
    }
    if (suborderId) {
      ApiRequest({
        url: 'Suborder/GetSuborderLog?suborderId=' + suborderId,
        method: 'get'
      }).then(res => {
        console.log(res.data.data)

      //  let v =  suborderLogs?.[0]?.Comment || "";
        setSuborderLogs(res.data.data)
      }).catch(() => {
        // 错误已由 axios interceptor 处理，这里静默处理避免未处理的 Promise rejection
      })
    }    
  }, [data])

  const BoxSize = data?.workOrder?.product?.baseProduct?.packagingType?.quantity || 1000;
  // 决定用"超一箱"还是"超10%"的判断规则
  const BoxLogic = (baseQuantity: number, productionQuantity: number) => {
    var BoxFlag = false;
    if (baseQuantity - productionQuantity > BoxSize ) {
      return BoxFlag = true;
    }
    return;
  };
  // 超一箱时的非常规操作触发原因（提交成功后写入日志用）
  const OVERRUN_EXCEPTIONAL_REASON = 'Overrun exceeds one box. Confirm completion? 差值数量超出1箱，确认完成吗？'
  const submitHandler = async (value: any) => {
    let pendingExceptionalLog: { page: string; triggerReason: string; reason?: string; createBy?: number } | null = null
    if (data.suborderId && machine.machineId && data?.receivedQuantity) {
      // const maxAllowedQuantity = data.receivedQuantity * 1.1; // 允许超过10%
      const baseQuantity = data.orginalQuantity ?? data.receivedQuantity ;
      const maxAllowedQuantity = baseQuantity * 1.1 - data.productionQuantity; // 允许超过10%    
      if (value.quantity > maxAllowedQuantity) {
        SweetAlertService.errorMessage('The Actual completed  quantity cannot exceed 10% more than the received order quantity.实际完成数量不能超过接受订单数量的10%以上。');
        return;
      }
    }
    if (data.suborderId && machine.machineId) {
      if (props.isComplete) {
        if (value.submitType === '1') {
          if (data?.receivedQuantity > value.quantity) {
            const baseQuantity = data.orginalQuantity ?? data.receivedQuantity;
            const isOverrun = BoxLogic(baseQuantity, value.quantity)
            if (isOverrun) {
              // 差额超一箱属于非常规操作：这里只做授权验证（不写日志），
              // 等真正的完成接口提交成功后再记录（见 suborder-complete-modal）
              const result = await SweetAlertService.warningConfirmVerifyOnly('Suborder', OVERRUN_EXCEPTIONAL_REASON)
              if (!result || (result as any)?.dismissed || !(result as any)?.value) {
                return
              }
              pendingExceptionalLog = {
                page: 'Suborder',
                triggerReason: OVERRUN_EXCEPTIONAL_REASON,
                reason: (result as any).value.reason,
                createBy: (result as any).value.employeeId,
              }
            } else {
              const result = await SweetAlertService.confirmMessage2('The actual completed quantity is less than the original work order quantity. Confirm completion? 实际完成数量少于原工单数量，确认完成吗？', { focusCancel: true,reverseButtons: true })
              if (!result) {
                return
              }
            }
          }
        }
        if (value.submitType === '2') {
          if (data?.receivedQuantity > value.quantity) {
            const result = await SweetAlertService.confirmMessage2('After partial completion, work order remains. Remaining qty to be completed. Confirm? 部分完成后，工单仍会保留，剩余数量仍需完成。确认吗？',  { focusCancel: true,reverseButtons: true })
            if (!result) {
              return
            }
          }
          else {
            SweetAlertService.errorMessage('The actual qty is not less than the received qty.Cannot Partial Complete.')
            return
          }
        }
      }
      const loggedInUserIdRef = Number(getCookie('suborder_operator_id', loggedInUserId));
      onOk({
        ...value,
        // operEmployeeId: machine?.operatorNavigation?.employeeId
        operEmployeeId: loggedInUserIdRef, // Use ref instead of state
        // 完成提交成功后由 SuborderCompleteModal 写入非常规操作日志
        ...(pendingExceptionalLog ? { pendingExceptionalLog } : {})
      })
    }
  }

  // 每箱数量（包装类型上的 quantity），无数据时默认 1000
  // const BoxSize = data?.workOrder?.product?.baseProduct?.packagingType?.quantity 
  const orderBaseQuantity = data?.orginalQuantity ?? data?.receivedQuantity
  const initialQuantity = machine?.machineTypeId === 2 ? (data?.orginalQuantity ?? data?.receivedQuantity) : undefined
  const [inputQuantity, setInputQuantity] = useState<number | undefined>(initialQuantity)
  useEffect(() => {
    if (isVisible) {
      setInputQuantity(initialQuantity)
    }
  }, [isVisible])
  const quantityWarning = (() => {
    if (inputQuantity === undefined || inputQuantity === null || !orderBaseQuantity) return null
    const shortfall = orderBaseQuantity - inputQuantity
    if (shortfall >= BoxSize) {
      return `差值超过一箱(${BoxSize}) / Shortfall exceeds one box`
    }
    if (shortfall > 0) {
      return '不满足原订单数量 / Less than original order quantity'
    }
    return null
  })()

  return (
    <Modal destroyOnClose={true} title={(props.isPackaging ? '打包/Packaging' : '子工单/Suborder') + ' - ' + (props.isComplete ? '完成/Complete' : '取单/Take')} visible={isVisible} onCancel={onCancel} width={1000}
      footer={[
        <Button type="primary" form="suborderModalForm" key="submit" htmlType="submit">提交/Submit</Button>
      ]}
    >
      <SuborderCommonPresentation data={data} />
      <Row>
        <Col style={{width: '60%'}}>
          <Form validateMessages={{required: 'required'}} onFinish={submitHandler} id="suborderModalForm">
            <br/>
            {
              (data?.suborderStatusId === 2 && data?.sequenceNo === 1 && [1, 2].includes(data?.workOrder.orderTypeId)) ? (
                <Form.Item name="rawMaterialBoxId" label={'原材料/RawMaterial Box'}>
                  {commonFormSelect('rawMaterialBox', rawMaterialBoxOptions[0] || [], ['boxCode'], false)}
                </Form.Item>
              ) : null
            }
            {
              (data?.suborderStatusId === 2 && data?.sequenceNo === 1 && [1, 2].includes(data?.workOrder.orderTypeId) && rawMaterialBoxOptions[1]) ? (
                <Form.Item name="rawMaterialBoxId2" label={'原材料2/RawMaterial Box2'}>
                  {commonFormSelect('rawMaterialBox', rawMaterialBoxOptions[1] || [], ['boxCode'], false)}
                </Form.Item>
              ) : null
            }
            {
              (data?.actionId === 3 && data?.workOrder?.orderTypeId === 3) ? (
                <Form.Item name="boxId" label={'半成品箱子/Semi Box'}>
                  {commonFormSelect('box', semiBoxOptions, ['boxCode'], false)}
                </Form.Item>
              ) : null
            }
            {
              (data?.suborderStatusId !== 1 && !(props.isPackaging && props.isComplete)) ? (
                <Row gutter={16}>
                  <Col span={12} style={{display: 'flex', alignItems: 'flex-start'}}>
                    <Form.Item
                      rules={[{required: true}]}
                      name='quantity'
                      label="实际数量/Actual Quantity"
                      initialValue={initialQuantity}
                    >
                      <InputNumber autoFocus onChange={(v: any) => setInputQuantity(typeof v === 'number' ? v : undefined)} />
                    </Form.Item>
                    {quantityWarning && <span style={{color: quantityWarning.startsWith('差值') ? 'red' : 'orange', whiteSpace: 'nowrap', marginLeft: 12, width: 0, overflow: 'visible', lineHeight: '32px'}}>{quantityWarning}</span>}
                  </Col>
                  {/* <Col span={12}>
                    <Form.Item rules={[{required: true}]} name='rejectQuantity' label={'不良数量/Reject Quantity'}>
                      <InputNumber />
                    </Form.Item>
                  </Col> */}
                </Row>
              ) : null
            }
            <Form.Item name='comment' label={'备注/Notes'}>
              <Input
                autoFocus={!props.isComplete}
                placeholder="请输入/please enter"
                defaultValue={ (suborderLogs?.[0] as { comment: string })?.comment || ""}
              />
            </Form.Item>            
            <Form.Item name='rawmaterialNotes' label={'原材料批号/Raw Material Batch Number'}>
              <Input
                autoFocus={!props.isComplete}
                placeholder="请输入/please enter"
                defaultValue={ (suborderLogs?.[0] as { rawmaterialNotes: string })?.rawmaterialNotes || ""}
              />
            </Form.Item>
            {
              (props.isPackaging || !props.isComplete) ? null : (
                <Form.Item rules={[{required: true}]} initialValue={'1'} name='submitType' label='提交类型/Submit Type'>
                  <Radio.Group>
                    <Radio value="1">全部完成/Full Completed</Radio>
                    {!(props?.data?.actionId==1) && (
                      <Radio value="2">
                        部分完成/Partial Completed
                      </Radio>
                    )}
                  </Radio.Group>
                </Form.Item>
              )
            }
          </Form>
        </Col>
      </Row>
    </Modal>
  )
}
